import * as ACTION_TYPES from 'actions/actionTypes';
import { WANDAS_PAGE } from 'store/constants';
import { WANDA_VENUE_MODAL } from 'components/pages/jobs/constants';

export const wandaVenueModalData = 'wandaVenueModalData';

export const initialState = {
  [WANDA_VENUE_MODAL.SHOW_WANDA_VENUES]: false,
};

export const reducer = (state = initialState[WANDAS_PAGE], action) => {
  switch (action.type) {
    case ACTION_TYPES.SET_WANDA_VENUE_MODAL_DATA: {
      const nextState = { ...state, [wandaVenueModalData]: action.payload };
      return nextState;
    }
    default:
      return {
        ...state,
      };
  }
};

export default reducer;
